import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form.tsx';
import { Textarea } from '@/components/ui/textarea.tsx';
import {
  InviteUserFormData,
  WELCOME_MESSAGE_MAX_LENGTH,
} from '@/features/users/schemas/invite-user.schema.ts';

export function CreateInviteUserWelcomeForm() {
  const { t } = useTranslation();
  const form = useFormContext<InviteUserFormData>();

  return (
    <div className="flex flex-col gap-3">
      <h2 className="font-semibold">{t('users.invite.steps.welcome.title')}</h2>

      <FormField
        control={form.control}
        name="welcomeMessage"
        render={({ field }) => {
          const value = field.value ?? '';
          return (
            <FormItem>
              <FormLabel>{t('users.invite.fields.welcomeMessage.label')}</FormLabel>
              <FormControl>
                <Textarea
                  maxLength={WELCOME_MESSAGE_MAX_LENGTH}
                  placeholder={t('users.invite.fields.welcomeMessage.placeholder')}
                  rows={5}
                  {...field}
                  value={value}
                />
              </FormControl>
              <div className="text-muted-foreground flex justify-end text-xs">
                {value.length}/{WELCOME_MESSAGE_MAX_LENGTH}
              </div>
              <FormMessage />
            </FormItem>
          );
        }}
      />
    </div>
  );
}
